import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { ExtraReducerBuilder } from '../../types/shared';
import { QuoteBuilderStateType } from '../../types/state';
import { showSalesRep } from '../endpoints/show-sales-rep';
import { buildElementId } from '../utilities/element-id';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue, upsertIssue } from '../utilities/issue-managers';

function getSalesRepFulfilled(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<typeof showSalesRep.Types.ResultType>,
) {
  const notFoundIssueId = buildIssueId({
    area: 'quote',
    field: 'salesRepId',
    type: 'not-found',
  });

  if (!action.payload) {
    upsertIssue(state, notFoundIssueId, {
      title: 'Sales Rep Not Found',
      description: 'Sales Rep could not be found',
      severity: 'error',
      area: 'quote',
      type: 'not-found',
      action: {
        type: 'modify',
        elementId: buildElementId({
          uuid: state.uuid,
          field: 'salesRepId',
        }),
      },
    });

    return;
  }

  const { name, email_addr, phone } = action.payload;

  deleteIssue(state, notFoundIssueId);

  state.salesRepName = name || null;
  state.salesRepEmail = email_addr || null;
  state.salesRepPhone = phone || null;
}

function getSalesRepRejected(state: WritableDraft<QuoteBuilderStateType>) {
  const rejectedIssueId = buildIssueId({
    area: 'quote',
    field: 'salesRepId',
    type: 'rejected',
  });

  upsertIssue(state, rejectedIssueId, {
    title: 'Server Error',
    description: 'Sales Rep could not be loaded',
    severity: 'warning',
    area: 'quote',
    type: 'rejected',
    action: {
      type: 'unrecoverable',
    },
  });

  state.salesRepName = null;
  state.salesRepEmail = null;
  state.salesRepPhone = null;
}

export function showSalesRepReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(showSalesRep.matchFulfilled, getSalesRepFulfilled);
  builder.addMatcher(showSalesRep.matchRejected, getSalesRepRejected);
}
